import { toInstant } from '@ems/contracts/timezones'

/**
 * A `datetime-local` value in the edition's zone, as a UTC instant (`…Z`).
 *
 * `toInstant` keeps the zone's offset (`2026-06-01T09:00:00+07:00`). Some endpoints validate with
 * Zod's plain `z.iso.datetime()`, which refuses an offset, so a body for those sends this form.
 * It is the same instant, written in UTC. `null` when the value is not a complete date and time.
 */
export function utcInstant(local: string, zone: string): string | null {
  const instant = toInstant(local, zone)
  return instant === null ? null : new Date(instant).toISOString()
}
